class PeaceTowerProductExplorer extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    this.buttons = [...this.querySelectorAll('[data-filter]')];
    this.cards = [...this.querySelectorAll('[data-product-card]')];
    this.status = this.querySelector('[data-filter-status]');

    for (const button of this.buttons) {
      button.addEventListener('click', () => this.filter(button.dataset.filter), {
        signal: this.abortController.signal,
      });
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = undefined;
  }

  filter(filter) {
    let visible = 0;

    for (const card of this.cards) {
      const matches = filter === 'all' || card.dataset.collections.split('|').includes(filter);
      card.hidden = !matches;
      if (matches) visible += 1;
    }

    for (const button of this.buttons) {
      button.setAttribute('aria-pressed', String(button.dataset.filter === filter));
    }

    if (this.status) {
      this.status.textContent = this.dataset.statusTemplate.replace('__COUNT__', String(visible));
    }
  }
}

if (!customElements.get('pt-product-explorer')) {
  customElements.define('pt-product-explorer', PeaceTowerProductExplorer);
}
